import { useGetContext, useGetProfile } from '../api/lending/lapiHooks';
export const RequireAuthenticatedSeller = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {
    context: { isLoading: loadingContext, isLoggedIn },
  } = useGetContext();
  const {
    profile: { user_type },
    loadingProfile,
  } = useGetProfile();

  if (loadingProfile || loadingContext) {
    return null;
  }

  // if a user is logged out and are staff, redirect without the 'redirect_to' param, as they need to
  // be directed by login-ui to eden, so they can impersonate
  if (!isLoggedIn && user_type === 'staff') {
    window.location.pathname = `/login/`;
    return null;
  }

  if (!isLoggedIn) {
    window.location.href = `/login/?redirect_to=${window.location.pathname}`;
    return null;
  }

  return <>{children}</>;
};
